export default __webpack_public_path__ + "static/anna-palko-mocuts-94cf2a23fa3dd087b848ed1d933689b7.mp4";